import React from 'react';
import { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import '../Estilos/CardDashboard.css';
import '../Estilos/Tooltip.css';
import { checkColor, checkStatus } from '../Funções/CardStatus';
import BotaoSublinhado from './BotaoSublinhado';
import { useNavigate } from 'react-router-dom';
/**
 *
 * @param nome (string) Nome do card.
 * @param id (string) ID do card.
 * @param eletricidade (boolean) Com ou sem eletricidade.
 * @param maxW (string) Largura máxima.
 * @param maxH (string) Altura máxima.
 * @param width (string) Largura padrão.
 * @param height (string) Altura padrão.
 * @param top (string) Distância top.
 * @returns
 */
export default function CardDashboardGeladeira(props) {
  const navigate = useNavigate();
  useEffect(() => {
    ReactTooltip.rebuild();
  }, [props.porta]);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [props.eletricidade]);

  const handleCardClick = () => {
    navigate(`/Geladeira/${props.environmentId}`);
  };

  return (
    <div
      style={{
        maxWidth: props.maxW !== undefined ? props.maxW : 540,
        maxHeight: props.maxH !== undefined ? props.maxH : 505,
        width: props.width !== undefined ? props.width : '28vw',
        backgroundColor: 'white',
        height: props.height !== undefined ? props.height : 540,
        marginRight: props.right !== undefined ? props.right : 0,
        marginTop: props.top !== undefined ? props.top : 0,
        borderRadius: 4,
        boxShadow: '0px 3px 6px #00000029',
      }}
    >
      <div className="CardView">
        <div id="CardDetalhes">
          <div id="TituloCardView">
            <h4 id="FonteCard" style={{ paddingLeft: 8 }}>
              {props.nome}
            </h4>
            <h6 id="FonteID" style={{ paddingLeft: 8 }}>
              ID: {props.id}
            </h6>
          </div>

          {
            <div className="toolTip">
              <img
                alt="eletrico"
                data-tip
                data-for={props.nome}
                id="IconeCard"
                src={require(props.eletricidade
                  ? '../Icones/icon_eletrico.png'
                  : '../Icones/raio_off.png')}
              />

              <ReactTooltip
                id={props.nome}
                backgroundColor={props.eletricidade ? '#40A631' : '#C64F3E'}
                place="top"
              >
                <p>{props.eletricidade ? 'Com Energia' : 'Sem Energia'}</p>
              </ReactTooltip>
            </div>
          }
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            padding: 0,
            justifyContent: 'center',
            flexDirection: 'column',
            height: 120,
            width: 110,
            borderRadius: 60,
            border: `3px solid ${checkColor(props.ok)}`,
          }}
        >
          {props.valor ? (
            <>
              <h2 className={`Valor ${checkStatus(props.ok)}`}>{props.valor}°C</h2>
            </>
          ) : (
            <p style={{ color: '#D7998E' }}>
              <strong>Sem leitura</strong>
            </p>
          )}
        </div>

        <h6 id="FonteID" style={{ paddingTop: 8 }}>
          {props.minimo}° min - {props.maximo}° máx
        </h6>
        <h6 id="FonteID" style={{ paddingTop: 0 }}>
          {props.data}
        </h6>

        <div id="CardDetalhes">
          <BotaoSublinhado fonteTamanho={14} nome="Visualizar" left={8} clicado={handleCardClick} />
          <div className="toolTip">
            <img
              id="IconeCard"
              data-tip
              data-for={props.id}
              alt="porta"
              src={require(props.porta === true
                ? '../Icones/icon_porta.png'
                : '../Icones/portaNG.png')}
            />

            <ReactTooltip
              id={props.id}
              backgroundColor={props.porta ? '#40A631' : '#C64F3E'}
              place="top"
            >
              <p>{props.porta ? 'Porta fechada' : 'Porta aberta'}</p>
            </ReactTooltip>
          </div>
        </div>
      </div>
    </div>
  );
}
